import React, { useEffect, useState } from 'react'
import { useI18n } from 'i18n'

const RESEND_SECONDS = 60

// "Didn't get it? Resend code", with the same 60 s cooldown the API applies.
const ResendCode = ({ onResend }) => {
  const { t } = useI18n()
  const [cooldown, setCooldown] = useState(RESEND_SECONDS)

  useEffect(() => {
    if (cooldown <= 0) return
    const id = setTimeout(() => setCooldown((s) => s - 1), 1000)
    return () => clearTimeout(id)
  }, [cooldown])

  const resend = async () => {
    if (await onResend()) setCooldown(RESEND_SECONDS)
  }

  return (
    <p className='mt-4 text-center text-sm text-slate-500'>
      {t('verify.noCode')}{' '}
      {cooldown > 0
        ? <span className='tabular-nums'>{t('verify.resendIn', { seconds: cooldown })}</span>
        : <button type='button' onClick={resend} className='font-semibold text-brand hover:underline'>{t('verify.resend')}</button>}
    </p>
  )
}

export default ResendCode
